module.exports = __webpack_public_path__ + "img/project2@2x.43b415a8.webp";